const ORG_COLORS = {
  UPCI: {
    badge: 'bg-purple-100 text-purple-800 dark:bg-purple-900/50 dark:text-purple-300',
    solid: 'bg-purple-600 text-white',
    dot: 'bg-purple-500',
  },
  ALJC: {
    badge: 'bg-red-100 text-red-800 dark:bg-red-900/50 dark:text-red-300',
    solid: 'bg-red-600 text-white',
    dot: 'bg-red-500',
  },
  AFF: {
    badge: 'bg-green-100 text-green-800 dark:bg-green-900/50 dark:text-green-300',
    solid: 'bg-green-600 text-white',
    dot: 'bg-green-500',
  },
  WPF: {
    badge: 'bg-blue-100 text-blue-800 dark:bg-blue-900/50 dark:text-blue-300',
    solid: 'bg-blue-600 text-white',
    dot: 'bg-blue-500',
  },
};

const DEFAULT_ORG_COLOR = {
  badge: 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300',
  solid: 'bg-gray-600 text-white',
  dot: 'bg-gray-400',
};

export const getOrgStyle = (org, variant = 'badge') => {
  if (!org) return DEFAULT_ORG_COLOR[variant] || DEFAULT_ORG_COLOR.badge;
  const key = org.toUpperCase();
  return (ORG_COLORS[key] || DEFAULT_ORG_COLOR)[variant] || DEFAULT_ORG_COLOR[variant];
};

export const getOrgBadgeClass = (org) => getOrgStyle(org, 'badge');
export const getOrgSolidClass = (org) => getOrgStyle(org, 'solid');
export const getOrgDotClass = (org) => getOrgStyle(org, 'dot');

export const KNOWN_ORGANIZATIONS = Object.keys(ORG_COLORS);
